export default function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center py-8">
      <div className="w-8 h-8 border-4 border-brand-sand border-t-brand-green rounded-full animate-spin" />
    </div>
  );
}
